<script setup>
import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Autoplay } from "swiper";
import { trackSwiperEvents } from "@/analyticsHelper";

SwiperCore.use([Autoplay]);

const props = defineProps({
    galleryData: {
        type: Array,
        required: true,
    },
});
</script>
<template>
    <swiper
        :loop="true"
        :slides-per-view="1"
        :centered-slides="true"
        :breakpoints="{
            '768': {
                slidesPerView: 2,
            },
            '1024': {
                slidesPerView: 3,
            },
        }"
        :autoplay="{
            delay: 2500,
            disableOnInteraction: false,
        }"
        data-slide-name="TEAM_MEMBER_GALLERY"
        @swiper="trackSwiperEvents"
    >
        <swiper-slide v-for="(slide, slideIndex) in galleryData" :key="slideIndex" class="w-full aspect-square">
            <a
                :href="slide.permalink"
                :title="slide.title"
                class="block group focus:ring-2 focus:ring-teal-600 active:ring-2 active:ring-teal-600"
            >
                <div class="aspect-square w-full">
                    <div class="w-full h-full overflow-hidden relative">
                        <img class="w-full h-full object-cover" :src="slide.permalink" :alt="slide.title" />
                    </div>
                </div>
            </a>
        </swiper-slide>
    </swiper>
</template>
